import { ApiService } from 'services';
import { omit, omitBy, get } from 'lodash';
const URL_OFFER = '/billboard/offers';

async function getOffers(tokenId, query) {
  const cleanQuery = omitBy(query, (value) => !value);
  const filter = get(cleanQuery, 'filter', {});

  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_OFFER}/token/${tokenId}`,
    queryParams: {
      ...omit(cleanQuery, 'filter'),
      ...filter,
    },
  });
}

async function getOffersMe(tokenId, query) {
  const cleanQuery = omitBy(query, (value) => !value);
  const filter = get(cleanQuery, 'filter', {});

  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_OFFER}/token/${tokenId}/me`,
    queryParams: {
      ...omit(cleanQuery, 'filter'),
      ...filter,
    },
  });
}

function getOfferMe(id) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_OFFER}/${id}/me`,
  });
}

function getOffer(id) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_OFFER}/${id}`,
  });
}

async function getOfferContact(id = null) {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_OFFER}/${id}/contact/me`,
  });
}

async function createOffer(body) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: URL_OFFER,
    body,
  });
}

function getOfferSettings(tokenId) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/billboard/settings/token/${tokenId}`,
  });
}

async function cancelOffer(id) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `${URL_OFFER}/${id}/cancel`,
  });
}

async function completeOffer(id) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `${URL_OFFER}/${id}/complete`,
  });
}

export default {
  getOffersMe,
  getOffers,
  getOffer,
  getOfferMe,
  getOfferContact,
  createOffer,
  cancelOffer,
  completeOffer,
  getOfferSettings,
};
